import React from 'react';
import CheckUpdate from '@components/ui/CheckUpdate';
import * as Styled from './DesktopStyles';
import Actions from './Actions';

function HeaderDesktop() {
  return (
    <Styled.WrapperPositionHeaderFixed data-testid="header-desktop">
      <Styled.Header>
        <Actions />
        <CheckUpdate />
      </Styled.Header>
    </Styled.WrapperPositionHeaderFixed>
  );
}

export default HeaderDesktop;
